var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M185.575,232.902H46.944C21.059,232.902,0,211.843,0,185.958V47.328 C0,21.443,21.059,0.384,46.944,0.384h138.631c25.884,0,46.944,21.059,46.944,46.944v138.631 C232.519,211.843,211.459,232.902,185.575,232.902z M46.944,30.061c-9.522,0-17.267,7.746-17.267,17.267v138.631 c0,9.522,7.746,17.267,17.267,17.267h138.631c9.522,0,17.267-7.746,17.267-17.267V47.328c0-9.522-7.746-17.267-17.267-17.267 C185.575,30.061,46.944,30.061,46.944,30.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M116.26,175.317c-8.195,0-14.838-6.645-14.838-14.838V72.806c0-8.194,6.643-14.838,14.838-14.838 s14.838,6.645,14.838,14.838v87.674C131.098,168.674,124.455,175.317,116.26,175.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M160.096,131.481H72.423c-8.195,0-14.838-6.645-14.838-14.838s6.643-14.838,14.838-14.838h87.672 c8.195,0,14.838,6.645,14.838,14.838S168.292,131.481,160.096,131.481z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M465.056,218.064H326.425c-17.732,0-32.106-14.374-32.106-32.106V47.327 c0-17.732,14.374-32.106,32.106-32.106h138.631c17.732,0,32.106,14.374,32.106,32.106v138.631 C497.162,203.69,482.788,218.064,465.056,218.064z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M465.056,232.902H326.425c-25.884,0-46.944-21.059-46.944-46.944V47.328 c0-25.884,21.059-46.944,46.944-46.944h138.631C490.94,0.384,512,21.443,512,47.328v138.631 C512,211.843,490.94,232.902,465.056,232.902z M326.425,30.061c-9.522,0-17.267,7.746-17.267,17.267v138.631 c0,9.522,7.746,17.267,17.267,17.267h138.631c9.522,0,17.267-7.746,17.267-17.267V47.328c0-9.522-7.746-17.267-17.267-17.267 C465.056,30.061,326.425,30.061,326.425,30.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M439.577,131.481h-87.672c-8.195,0-14.838-6.645-14.838-14.838s6.643-14.838,14.838-14.838h87.672 c8.195,0,14.838,6.645,14.838,14.838S447.772,131.481,439.577,131.481z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M185.575,496.777H46.944c-17.732,0-32.106-14.374-32.106-32.106V326.04 c0-17.732,14.374-32.106,32.106-32.106h138.631c17.732,0,32.106,14.374,32.106,32.106v138.631 C217.681,482.403,203.307,496.777,185.575,496.777z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M185.575,511.616H46.944C21.059,511.616,0,490.557,0,464.672V326.04 c0-25.884,21.059-46.944,46.944-46.944h138.631c25.884,0,46.944,21.059,46.944,46.944v138.631 C232.519,490.557,211.459,511.616,185.575,511.616z M46.944,308.775c-9.522,0-17.267,7.746-17.267,17.267v138.631 c0,9.522,7.746,17.267,17.267,17.267h138.631c9.522,0,17.267-7.746,17.267-17.267V326.042c0-9.522-7.746-17.267-17.267-17.267 L46.944,308.775L46.944,308.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M85.262,441.192c-3.799,0-7.594-1.45-10.492-4.346c-5.794-5.794-5.794-15.19,0-20.986l61.994-61.993 c5.794-5.793,15.188-5.791,20.984,0c5.794,5.794,5.794,15.19,0,20.986l-61.994,61.993 C92.858,439.742,89.059,441.192,85.262,441.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M147.257,441.192c-3.797,0-7.594-1.45-10.492-4.346L74.77,374.853 c-5.794-5.794-5.796-15.19,0-20.986c5.794-5.793,15.19-5.793,20.984,0l61.994,61.993c5.794,5.794,5.796,15.19,0,20.986 C154.851,439.742,151.054,441.192,147.257,441.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M465.056,511.616H326.425c-25.884,0-46.944-21.059-46.944-46.944V326.04 c0-25.884,21.059-46.944,46.944-46.944h138.631c25.884,0,46.944,21.059,46.944,46.944v52.127c0,8.194-6.643,14.838-14.838,14.838 s-14.838-6.645-14.838-14.838V326.04c0-9.522-7.746-17.267-17.267-17.267H326.425c-9.522,0-17.267,7.746-17.267,17.267v138.631 c0,9.522,7.746,17.267,17.267,17.267h138.631c9.522,0,17.267-7.746,17.267-17.267v-16.775c0-8.194,6.643-14.838,14.838-14.838 S512,439.703,512,447.897v16.775C512,490.557,490.94,511.616,465.056,511.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M439.577,383.359h-87.672c-8.195,0-14.838-6.645-14.838-14.838s6.643-14.838,14.838-14.838h87.672 c8.195,0,14.838,6.645,14.838,14.838S447.772,383.359,439.577,383.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M439.577,437.028h-87.672c-8.195,0-14.838-6.645-14.838-14.838c0-8.194,6.643-14.838,14.838-14.838 h87.672c8.195,0,14.838,6.645,14.838,14.838C454.415,430.383,447.772,437.028,439.577,437.028z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculate);
export default __webpack_public_path__ + "static/media/calculate.a76d69a2.svg";
export { ForwardRef as ReactComponent };